var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import * as Utils from "../services/utils";
import { uuidv4 } from "../services/utils";
var _state = {};
var _components = {};
$(function () {
    _components.$loginTab = $('#loginTab').on('click', openTabLogin_onClick);
    _components.$phoneTab = $('#phoneTab').on('click', openTabPhone_onClick);
    _components.$loginContent = $('#loginContent');
    _components.$phoneContent = $('#phoneContent');
    _components.$checkCodeContent = $('#checkCodeContent');
    _components.$loginBtn = $('#loginButton').on('click', sendLoginInfo_onClick);
    _components.$inputLogin = $('#Login');
    _components.$inputPassword = $('#Password');
    _components.$inputPhoneOrEmail = $('#PhoneOrEmail');
    _components.$phoneOrEmailBtn = $('#phoneOrEmailButton').on('click', openConfirmDialog_onClick);
    _components.$checkCodeBtn = $('#checkCodeButton').on('click', sendCode_onClick);
    _components.$inputCode = $('#Code');
    _components.kConfirmationDialog = $('#confirmationDialog').data('kendoWindow');
    _components.$getCodeBtn = $('#confirmButton').on('click', sendPhoneOrEmail_onClick);
    _components.$helpLink = $('#helpLink').on('click', getHelp_onClick);
    _components.helpPrompt = $('#helpDialog').data('kendoWindow');
    _components.$redirectToPage = $('#redirectToPage');
});
var token = uuidv4();
$('.form-auth__form-group_input').on('click', clear);
$('#Password').attr("type", "password");
function sendLoginInfo_onClick(e) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var login, password, data, response, ex_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    e.preventDefault();
                    clear();
                    login = (_a = _components.$inputLogin) === null || _a === void 0 ? void 0 : _a.val();
                    if (!login) {
                        setError('Укажите логин');
                        return [2 /*return*/];
                    }
                    password = (_b = _components.$inputPassword) === null || _b === void 0 ? void 0 : _b.val();
                    if (!password) {
                        setError('Укажите пароль');
                        return [2 /*return*/];
                    }
                    data = {
                        Login: login,
                        Password: password,
                        RedirectToPage: (_c = _components.$redirectToPage) === null || _c === void 0 ? void 0 : _c.val()
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    Utils.showIndicator(true);
                    return [4 /*yield*/, axios.post('/auth/login', data)];
                case 2:
                    response = _d.sent();
                    if (response.data) {
                        if (response.data.addressee) {
                            window.location.href = "".concat(response.data.url, "?").concat(response.data.addressee);
                            return [2 /*return*/, false];
                        }
                        window.location.href = response.data.url;
                    }
                    return [3 /*break*/, 5];
                case 3:
                    ex_1 = _d.sent();
                    handleRequestException(ex_1);
                    return [3 /*break*/, 5];
                case 4:
                    Utils.showIndicator(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function sendPhoneOrEmail_onClick(e) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var phoneOrEmail, data, response, ex_2;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    e.preventDefault();
                    clear();
                    (_a = _components.kConfirmationDialog) === null || _a === void 0 ? void 0 : _a.center().close();
                    phoneOrEmail = (_b = _components.$inputPhoneOrEmail) === null || _b === void 0 ? void 0 : _b.val();
                    if (!phoneOrEmail) {
                        setError('Введите номер телефона или Email');
                    }
                    data = {
                        PhoneOrEmail: phoneOrEmail,
                        Token: token
                    };
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    Utils.showIndicator(true);
                    return [4 /*yield*/, axios.post('/auth/phone-or-email', data)];
                case 2:
                    response = _f.sent();
                    if (response.status == 200) {
                        (_c = _components.$phoneTab) === null || _c === void 0 ? void 0 : _c.attr('class', 'form-auth__button');
                        (_d = _components.$phoneContent) === null || _d === void 0 ? void 0 : _d.attr('style', 'display:none');
                        (_e = _components.$checkCodeContent) === null || _e === void 0 ? void 0 : _e.show();
                        setTimeout(function () { var _a; (_a = _components.$inputCode) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
                    }
                    console.log(response);
                    return [3 /*break*/, 5];
                case 3:
                    ex_2 = _f.sent();
                    handleRequestException(ex_2);
                    return [3 /*break*/, 5];
                case 4:
                    Utils.showIndicator(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function sendCode_onClick(e) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var code, data, response, ex_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    clear();
                    code = (_a = _components.$inputCode) === null || _a === void 0 ? void 0 : _a.val();
                    if (!code) {
                        setError('Введите код авторизации');
                    }
                    data = {
                        Code: code,
                        Token: token
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    Utils.showIndicator(true);
                    return [4 /*yield*/, axios.post('/auth/check-code', data)];
                case 2:
                    response = _b.sent();
                    if (response.data) {
                        window.location.href = response.data;
                        Utils.showIndicator(true);
                    }
                    console.log(response);
                    return [3 /*break*/, 5];
                case 3:
                    ex_3 = _b.sent();
                    handleRequestException(ex_3);
                    return [3 /*break*/, 5];
                case 4:
                    Utils.showIndicator(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function openTabLogin_onClick(e) {
    var _a, _b, _c, _d, _e;
    e.preventDefault();
    clear();
    clearInputs();
    setTimeout(function () { var _a; (_a = _components.$inputLogin) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
    // _components.$loginTab?.attr('class', 'auth-page__button_active');
    (_a = _components.$loginTab) === null || _a === void 0 ? void 0 : _a.attr('class', 'form-auth__button_active');
    //_components.$phoneTab?.attr('class', 'auth-page__button');
    (_b = _components.$phoneTab) === null || _b === void 0 ? void 0 : _b.attr('class', 'form-auth__button');
    (_c = _components.$loginContent) === null || _c === void 0 ? void 0 : _c.show();
    (_d = _components.$phoneContent) === null || _d === void 0 ? void 0 : _d.hide();
    (_e = _components.$checkCodeContent) === null || _e === void 0 ? void 0 : _e.hide();
}
function openTabPhone_onClick(e) {
    var _a, _b, _c, _d, _e;
    e.preventDefault();
    clear();
    clearInputs();
    setTimeout(function () { var _a; (_a = _components.$inputPhoneOrEmail) === null || _a === void 0 ? void 0 : _a.focus(); }, 500);
    // _components.$loginTab?.attr('class', 'auth-page__button');
    // _components.$phoneTab?.attr('class', 'auth-page__button_active');
    (_a = _components.$loginTab) === null || _a === void 0 ? void 0 : _a.attr('class', 'form-auth__button');
    (_b = _components.$phoneTab) === null || _b === void 0 ? void 0 : _b.attr('class', 'form-auth__button_active');
    (_c = _components.$loginContent) === null || _c === void 0 ? void 0 : _c.hide();
    (_d = _components.$phoneContent) === null || _d === void 0 ? void 0 : _d.show();
    (_e = _components.$checkCodeContent) === null || _e === void 0 ? void 0 : _e.hide();
}
function openConfirmDialog_onClick(e) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var phoneOrEmail;
        return __generator(this, function (_c) {
            e.preventDefault();
            clear();
            phoneOrEmail = (_a = _components.$inputPhoneOrEmail) === null || _a === void 0 ? void 0 : _a.val();
            if (!phoneOrEmail) {
                setError('Укажите телефон или email');
                return [2 /*return*/];
            }
            (_b = _components.kConfirmationDialog) === null || _b === void 0 ? void 0 : _b.center().open();
            return [2 /*return*/];
        });
    });
}
function clear() {
    $('.errorMessage').empty();
    $('.form-auth__form-group_input').each(function (n, el) {
        var $el = $(el);
        $el.removeClass('error-input');
    });
}
function clearInputs() {
    $('.form-auth__form-group_input').each(function (n, el) {
        var $el = $(el);
        $el.val('');
    });
}
function setError(message) {
    $('.form-auth__form-group_input').each(function (n, el) {
        var $el = $(el);
        $el.addClass('error-input');
    });
    $('.errorMessage').html(message);
}
function handleRequestException(ex) {
    if (ex.response) {
        setError(ex.response.data);
    }
    else if (ex.request) {
        console.log('ex.request');
        console.log(ex.request);
    }
    else if (ex.message) {
        console.log('ex.message');
        console.log(ex.message);
    }
}
function getHelp_onClick() {
    var _a;
    (_a = _components.helpPrompt) === null || _a === void 0 ? void 0 : _a.center().open();
}
$(document).keypress(function (e) {
    if (e.which == 13) {
        if ($('#loginContent').is(':visible')) {
            sendLoginInfo_onClick(e);
            return false;
        }
        if ($('#confirmationDialog').parent().hasClass('k-display-inline-flex')) {
            sendPhoneOrEmail_onClick(e);
            return false;
        }
        if ($('#phoneContent').is(':visible')) {
            openConfirmDialog_onClick(e);
            return false;
        }
        if ($('#checkCodeContent').is(':visible')) {
            sendCode_onClick(e);
            return false;
        }
    }
});
